import { CUSTOM_FIELD_LABEL_PERMISSION_TYPES } from '@/domains/detail/folder/constants';
import { FolderService } from '@/domains/detail/folder/types/folder-service.interface';
import { injectService } from '@/inversify.config';
import { createSharedComposable } from '@vueuse/core';
import _ from 'lodash';
import { computed, ref } from 'vue';
import { useDetailRoute } from '@/presentation/pages/workspace-detail/composables/use-detail-route';
export const useFolder = createSharedComposable(() => {
    const folderService = injectService(FolderService);
    const { folderId } = useDetailRoute();
    const folderInfo = ref({});
    folderService.subscribeFolderInfo((newVal) => {
        folderInfo.value = newVal;
    });
    const folderCapacity = ref({});
    folderService.subscribeFolderCapacity((newVal) => {
        folderCapacity.value = newVal;
    });
    const folderPermission = ref({});
    folderService.subscribeFolderPermission((newVal) => {
        folderPermission.value = newVal;
    });
    /** 权限获取失败, 或有权限 */
    const ensureFolderPermission = computed(() => {
        return _.isEmpty(folderPermission.value) || folderPermission.value.enable_access;
    });
    const enableCustomFieldLabel = computed(() => {
        return _.includes(CUSTOM_FIELD_LABEL_PERMISSION_TYPES, folderPermission.value.field_permission_type);
    });
    const initFolder = async (spaceId, folderId) => {
        if (!spaceId || !folderId)
            return;
        await folderService.initFolder(spaceId, folderId);
        // 异步更新 folder 访问时间
        if (ensureFolderPermission.value) {
            folderService.updateFolderAccessTime(folderId);
        }
    };
    const updateFolderInfo = (folder) => {
        folderService.updateFolderInfo(folder);
    };
    const updateFolderInfoImportInfo = (importInfo) => {
        folderService.updateFolderInfoImportInfo(importInfo);
    };
    const updateFolderPermission = (permission) => {
        folderService.updateFolderPermission(permission);
    };
    const updateFolderTotalCountByKey = (key, count) => {
        folderService.updateFolderTotalCountByKey(key, count);
    };
    return {
        folderInfo,
        folderCapacity,
        folderPermission,
        ensureFolderPermission,
        folderId,
        enableCustomFieldLabel,
        initFolder,
        updateFolderInfo,
        updateFolderInfoImportInfo,
        updateFolderPermission,
        updateFolderTotalCountByKey,
    };
});
